import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { SettingForm } from '@/features/system-settings-form'
import { useSetting } from '@/shared/api/system-settings'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/administration/settings/update/$settingId')({
  staticData: {
    meta: {
      title: 'Редактировать настройку',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { settingId } = Route.useParams()
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { data, isLoading } = useSetting({ id: settingId, enabled: true })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактировать настройку')}>
      {!isLoading && <SettingForm mode="update" setting={data} onClose={close} />}
    </Offcanvas>
  )
}
